import _axios from '@/utils/request'
const moduleServices = {
    // 模块列表
    getModuleList (params) {
        return _axios('post', `/ms-shulan-hospital/v1/module/list`, params)
    },
    // 模块列表
    addModule (params) {
        return _axios('post', `/ms-shulan-hospital/v1/module/add`, params)
    },
    // 模块下线
    offModule (moduleId) {
        return _axios('get', `/ms-shulan-hospital/v1/module/down/${moduleId}`)
    },
    // 模块上线
    onModule (moduleId) {
        return _axios('get', `/ms-shulan-hospital/v1/module/up/${moduleId}`)
    },
    // 模块下移
    moveDownModule (moduleId) {
        return _axios('get', `/ms-shulan-hospital/v1/module/move_down/${moduleId}`)
    },
    // 模块上移
    moveUpModule (moduleId) {
        return _axios('get', `/ms-shulan-hospital/v1/module/move_up/${moduleId}`)
    },
    // 专家讲堂新增模块
    addExpertModule (param) {
        return _axios('post', `/ms-shulan-hospital/v1/module/module/addExpert`, param)
    },
    // 编辑模块名称
    updateModule (param) {
        return _axios('post', `/ms-shulan-hospital/v1/module/update`, param)
    },
    // 删除模块下的专家讲堂
    deleteExpertModule (expertSeminarId, moduleId) {
        return _axios('delete', `/ms-shulan-hospital/v1/module/module/expert/delete/${expertSeminarId}/${moduleId}`)
    },
    // 下移模块下的专家讲堂
    moveDownExpertModule (expertSeminarId, moduleId) {
        return _axios('get', `/ms-shulan-hospital/v1/module/module/expert/move_down/${expertSeminarId}/${moduleId}`)
    },
    // 上移模块下的专家讲堂
    moveUpExpertModule (expertSeminarId, moduleId) {
        return _axios('get', `/ms-shulan-hospital/v1/module/module/expert/move_up/${expertSeminarId}/${moduleId}`)
    }
}

export default moduleServices
